<div class="date-picker-container">
    <button mat-icon-button (click)="previousPeriod(dateRange)" [disabled]="disabled">
        <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span class="period-label">{{ periodLabel }}</span>
    <button mat-icon-button (click)="nextPeriod(dateRange)" [disabled]="disabled">
        <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
</div>
